module.exports = __webpack_public_path__ + "static/media/4-10.eb80b870.mp3";